import { graphql, useStaticQuery } from 'gatsby';
import { PropTypes } from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from '@reach/router';
import { DEFAULT_METADATA } from '../../constants';

const Metadata = ({ title, meta }) => {
  title = title || DEFAULT_METADATA.title;
  meta = meta || DEFAULT_METADATA.meta;

  const location = useLocation();
  const { description, image, title: metaTitle, twitterCard } = meta;
  const data = useStaticQuery(graphql`
    query PageQuery {
      site {
        siteMetadata {
          siteURL
        }
      }
    }
  `);
  const origin = data.site.siteMetadata.siteURL;
  const imageUrl = origin + image;
  const pathUrl = origin + location.pathname;
  return (
    <Helmet>
      <title>{title}</title>

      {/* default tags */}
      <meta name='description' content={description} />
      <meta name='image' content={imageUrl} />

      {/* open graph tags */}
      <meta property='og:url' content={pathUrl} />
      <meta property='og:title' content={metaTitle} />
      <meta property='og:description' content={description} />
      <meta property='og:image' content={imageUrl} />

      {/* twitter card tags */}
      <meta name='twitter:card' content={twitterCard} />
      <meta name='twitter:title' content={metaTitle} />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image' content={imageUrl} />

      <script src='https://fast.wistia.net/assets/external/E-v1.js' async />
    </Helmet>
  );
};

Metadata.propTypes = {
  location: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  meta: PropTypes.shape({
    description: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    twitterCard: PropTypes.string.isRequired,
  }).isRequired,
};

export default Metadata;
